// extracted by mini-css-extract-plugin
export var container = "_4b-0";
export var icon = "_4b-1";
export var text = "_4b-2";